import { SVGProps } from 'react';

const Download = ({
  width = 18,
  height = 20,
  fill = '#2A2A2A',
  ...otherProps
}: SVGProps<SVGSVGElement>) => (
  <svg
    height={height + 'px'}
    width={width + 'px'}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 20"
    {...otherProps}>
    <path
      d="M0 19C0 18.4477 0.447715 18 1 18H17C17.5523 18 18 18.4477 18 19C18 19.5523 17.5523 20 17 20H1C0.447716 20 0 19.5523 0 19Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.99977 12.4873L7.99977 1C7.99977 0.447716 8.44749 0 8.99977 0C9.55206 0 9.99977 0.447716 9.99977 1L9.99977 12.4827L13.2398 9.24265C13.6304 8.85212 14.2635 8.85212 14.654 9.24265C15.0446 9.63317 15.0446 10.2663 14.654 10.6569L9.7705 15.5404C9.7508 15.5641 9.72984 15.5871 9.70761 15.6094C9.31708 15.9999 8.68392 15.9999 8.2934 15.6094L3.33685 10.6528C2.94633 10.2623 2.94633 9.62913 3.33685 9.2386C3.72738 8.84808 4.36054 8.84808 4.75107 9.2386L7.99977 12.4873Z"
      fill={fill}
    />
  </svg>
);

export default Download;
